var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "url(#paint0_radial_25993_211147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43185 14.0464L4.60547 11.2353L6.71379 9.12695L11.6027 14.0006C11.8166 14.2145 12.1832 14.2145 12.3971 14.0006L17.286 9.12695L19.3944 11.2353L16.568 14.0617C16.0485 14.5811 15.3305 14.8867 14.5818 14.8867H9.41795C8.66935 14.8714 7.96658 14.5811 7.43185 14.0464Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_25993_211147",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4408 4.11184) rotate(135.684) scale(21.4426 21.4441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#9CFFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39372,
    stopColor: "#32F26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610145,
    stopColor: "#00D15F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeeam);
export default __webpack_public_path__ + "static/media/Veeam.f121b60afeb131f089ad5dfbeef271dd.svg";
export { ForwardRef as ReactComponent };